import { Popover } from "@mantine/core";

import type { CalendarActions } from "~/modules/dashboard/components/TimeTrackingCalendar/calendarDays.ts";
import { TrackingCard } from "~/modules/dashboard/components/TimeTrackingCalendar/TrackingCard.tsx";
import { TrackingRow } from "~/modules/dashboard/components/TimeTrackingCalendar/TrackingRow.tsx";
import type { TimeTrackingExtendedType } from "~/modules/timeTracking/api/timeTracking/timeTrackingTypes.ts";

type Props = CalendarActions & {
	timeTracking: TimeTrackingExtendedType;
};

// A cell is too narrow for the details, so they open in a popover at the tracking.
export function TimeTrackingPopoverBar(props: Props) {
	const { timeTracking, selectedTimeTrackingId, setSelectedTimeTrackingId, openUpdate, openDelete } = props;
	const isSelected = timeTracking.id === selectedTimeTrackingId;
	const close = () => setSelectedTimeTrackingId(null);

	return (
		<Popover opened={isSelected}
				 onClose={close}
				 position="bottom-start">
			<Popover.Target>
				<div>
					<TrackingRow timeTracking={timeTracking}
								 size="sm"
								 hideHours
								 isOpen={isSelected}
								 onClick={() => setSelectedTimeTrackingId(isSelected ? null : timeTracking.id)} />
				</div>
			</Popover.Target>
			<Popover.Dropdown className="!w-80 max-w-[calc(100vw-2rem)] !border-0 !bg-transparent !p-0 !shadow-none">
				<TrackingCard timeTracking={timeTracking}
							  onClickEdit={() => {
								  close();
								  openUpdate(timeTracking.id);
							  }}
							  onClickDelete={() => {
								  close();
								  openDelete(timeTracking.id);
							  }}
							  onClickClose={close} />
			</Popover.Dropdown>
		</Popover>
	);
}
